// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"429":"d229b3e8","532":"157b1d2e","721":"157b1d2e"}[chunkId] + ".chunk.css";
};